import React from 'react'
import styles from './index.module.less'
import { Tabs } from 'antd'
import Day1 from './Day1'
// import Day2 from './Day2'
export default function Agenda() {
  return (
    <div className={styles.box}>
      <p className={styles.big_title}>会议议程</p>
      <div className={styles.cont}>
        <Tabs
          defaultActiveKey='1'
          items={[
            {
              label: 'Day1',
              key: '1',
              children: <Day1 />
            },
            // {
            //   label: 'Day2',
            //   key: '2',
            //   children: <Day2 />
            // },
          ]}
        />
      </div>
    </div>
  )
}
